import gql from 'graphql-tag';

export const QUERY_ALL_BRANDS = gql`query AllBrands {
  paBrands(where: {hideEmpty: true}, first: 999) {
    nodes {
      name
      databaseId
      description
      count
      uri
      seo {
        title
      }
    }
  }
}
`;

export default QUERY_ALL_BRANDS;